(function () {
'use strict';

angular
    .module('signalrRoutes', [
        'signalrControllers'
    ])
    .config(router);

router.$inject = ['$stateProvider'];

function router($stateProvider) {

    $stateProvider
            .state('signalr', {
                url: '/SignalR',
                controller: 'ChatController',
                templateUrl: require('./chat.tpl.html')
            });
}
})();